import { useEffect, useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  useTheme,
  NumberField,
  useTranslate,
} from "react-admin";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import AccountPayableAgeExpandList from "../../components/accountPayableAges/expand/AccountPayableAgeExpandList";
import accountPayableAgeFilterList from "../../components/accountPayableAges/filter/accountPayableAgeFilterList";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import AccountPayableAgeFooterList from "../../components/accountPayableAges/footer/AccountPayableAgeFooterList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";
import ManualReportList from "../../components/reports/ManualReportList";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const ExpandAll = () => {
  useEffect(() => {
    const expandAllBtn = document.querySelector(
      "table.RaDatagrid-table .RaDatagrid-thead .RaDatagrid-headerRow .RaDatagrid-expandHeader .RaDatagrid-expandIcon:not(.RaDatagrid-expanded)"
    );
    if (expandAllBtn) {
      var clickEvent = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      expandAllBtn.dispatchEvent(clickEvent);
    }
  }, []);
  return null;
};

const AccountPayableAgeList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
      cut_off: lastDate,
      kind: "per_surat_jalan",
    });
  const [theme] = useTheme("light");
  const t = useTranslate();

  const dayTrans = t("mine.label.day");

  const list = useMemo(
    () => (
      <ManualReportList
        storeKey={false} // Disabling Parameters Persistence
        title="mine.list_title.account_payable_age"
        empty={false}
        // aside={<AccountPayableAgeAsideList />}
        actions={<DownloadAction />}
        filters={accountPayableAgeFilterList(permissions)}
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date", "cut_off"]}
        queryOptions={{ meta: { sort: ["suppliers.code ASC"] } }} // overide default sort
        sx={{
          flexDirection: "column",
        }}
      >
        <DatagridConfigurable
          body={<MyDatagridBody footer={<AccountPayableAgeFooterList />} />}
          bulkActionButtons={false}
          // rowClick={rowClickHandler}
          // expandSingle={true}
          isRowExpandable={(row) => !!row.company_debts}
          expand={<AccountPayableAgeExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField label="mine.label.depo" source="company_alias" />
          ) : null}
          <TextField
            source="code"
            label="mine.label.code"
            emptyText="-"
            sx={{ width: "5%" }}
          />
          <TextField source="name" label="mine.label.name" />
          <ExpandAll />
          <NumberField source="total_ap" label="mine.label.debt" />
          <NumberField source="total_overdue" label="Overdue" />
          <NumberField source="total_less_30" label={"< 30 " + dayTrans} />
          <NumberField
            source="total_between_30_60"
            label={"30 - 60 " + dayTrans}
          />
          <NumberField
            source="total_between_61_90"
            label={"61 - 90 " + dayTrans}
          />
          <NumberField
            source="total_between_91_120"
            label={"91 - 120 " + dayTrans}
          />
          <NumberField
            source="total_between_121_150"
            label={"121 - 150 " + dayTrans}
          />
          <NumberField source="total_above_150" label={"> 150 " + dayTrans} />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues, dayTrans]
  );

  return list;
};

export default AccountPayableAgeList;
